import script from "./Collection.vue?vue&type=script&setup=true&lang=ts"
export * from "./Collection.vue?vue&type=script&setup=true&lang=ts"

import "./Collection.vue?vue&type=style&index=0&id=ec30df72&lang=scss"

const __exports__ = script;

export default __exports__